export default async function asyncMap<T, R>(
  array: T[],
  callback: (item: T, index: number, array: T[]) => Promise<R>,
): Promise<R[]> {
  const results: R[] = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < array.length; i++) {
    // eslint-disable-next-line no-await-in-loop
    results.push(await callback(array[i], i, array));
  }
  return results;
}
